/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface SetupGuideIntegrateSourceHeaderArgs {
  isComplete: boolean;
  customers: number;
  attributes: number;
  events: number;
  onDataTypeClick: () => unknown;
}

export default class SetupGuideIntegrateSourceHeader extends Component<SetupGuideIntegrateSourceHeaderArgs> {}
